'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ToggleFilter: ()=>ToggleFilter_ToggleFilter
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../Toggle/index.cjs");
const external_ToggleFilter_variants_cjs_namespaceObject = require("./ToggleFilter.variants.cjs");
const external_Text_index_cjs_namespaceObject = require("../../Text/index.cjs");
const ToggleFilter_ToggleFilter = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ label, helperText, onToggleChange, defaultEnabled = false, disabled = false, textProps, toggleProps, name, required, ...props }, ref) {
    const [isEnabled, setIsEnabled] = (0, external_react_namespaceObject.useState)(defaultEnabled);
    const toggleName = name ?? `toggle-${label.replace(/\s+/g, '-').toLowerCase()}`;
    const state = disabled ? 'disabled' : 'enabled';
    const { containerSlot, labelContainerSlot, labelSlot, helperTextSlot } = (0, external_ToggleFilter_variants_cjs_namespaceObject.toggleFilterVariants)({
        ...props,
        state
    });
    const toggleState = ()=>{
        if (!disabled) {
            const newState = !isEnabled;
            setIsEnabled(newState);
            onToggleChange(newState);
        }
    };
    const handleToggle = (checked)=>{
        if (!disabled) {
            setIsEnabled(checked);
            onToggleChange(checked);
        }
    };
    const handleContainerClick = (e)=>{
        if (e.target instanceof Element && e.target.closest('[role="switch"]')) return;
        if (!disabled) toggleState();
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: containerSlot(),
        onClick: handleContainerClick,
        tabIndex: -1,
        "aria-disabled": disabled,
        "data-testid": "toggle-filter-container",
        ...props,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: labelContainerSlot(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("label", {
                        htmlFor: toggleName,
                        className: labelSlot(),
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            textStyle: "heading5",
                            ...textProps,
                            children: label
                        })
                    }),
                    'string' == typeof helperText && '' !== helperText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                        textStyle: "body3",
                        className: helperTextSlot(),
                        children: helperText
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Toggle, {
                checked: isEnabled,
                disabled: disabled,
                onToggle: handleToggle,
                size: "24",
                emphasis: "regular",
                name: toggleName,
                required: required,
                ref: ref,
                ...toggleProps
            })
        ]
    });
});
exports.ToggleFilter = __webpack_exports__.ToggleFilter;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ToggleFilter"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
